import {Component, Input, OnInit} from '@angular/core';
import {Favorite} from '@models/favorite';

@Component({
  selector: 'app-fisca-mobile',
  templateUrl: './fisca-mobile.component.html',
  styleUrls: ['./fisca-mobile.component.scss']
})
export class FiscaMobileComponent implements OnInit {
    @Input() favorite: Favorite;
    @Input() preview: boolean;

    constructor() {
    }

    ngOnInit() {
    }
}
